import styled from "styled-components";
import { media } from "../../../../../components/common/media";

const ContactModalContainer = styled.div`
  width: 100%;
  max-width: 600px;
  h4 {
    font-weight: 700;
    margin-bottom: 30px;
    margin-top: -30px;
    font-size: 24px;
    max-width: 200px;
  }

  label {
    color: #000;
    font-weight: 700;
    width: 100%;
    margin-bottom: 10px;

    &.checkbox-text {
      color: #000;
      font-weight: 400;
      cursor: pointer;
      font-size: 13px;
      padding-top: 30px;
    }
  }

  .modal-header {
    border-bottom: 0;

    .close {
      opacity: 1;
      margin-top: -2px;
      padding: 0 1rem;
    }
  }

  .modal-body {
    padding: 20px;

    textarea {
      height: 100px;
      padding: 10px;
    }
  }

  input[type="number"],
  input[type="text"],
  select,
  textarea {
    width: 100%;
    height: 42px;
    border: 1px solid #ccc;
    padding: 0 10px;
    border-radius: 0;
  }

  .row {
    margin-bottom: 15px;
  }

  input[type="submit"] {
    background: ${props => props.theme.colorFlamingo};
    border: 0;
    color: #fff;
    padding: 10px 35px;
    transition: all 0.6s ease 0s;
    font-weight: 700;
    margin-top: 20px;
  }

  &#thankyou_modal {
    p {
      font-weight: 700;
      color: #000;
      font-size: 36px;
      ${media.tablet`
        font-size: 20px;
      `};

      span {
        font-weight: 400;
        color: #000;
        font-size: 20px;
        ${media.tablet`
          font-size: 16px;
        `};
      }
    }

    img {
      margin-bottom: 30px;
    }
  }
`;

export default ContactModalContainer;
